import React, { Component } from 'react';
import $ from 'jquery';
import FJSlider from './FJSlider';
import className from 'classnames';
import Styles from './FJResSliderInput.module.less';
import FJConstant from '../../../constants/FJConstant';
import FJMathUtil from '../../../util/FJMathUtil';

const UNDEFINED_VALUE = '- -';
// 资源栏这边的slider（包含 label， slider, input）
class FJResSliderInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFocus: false,
            isGray: false,
        };
    }

    componentDidMount() {
        this._input.addEventListener('dragstart', e => {
            e.preventDefault();
        });
        this.updateSlider(this.props.value);
    }

    componentDidUpdate(preProps) {
        if (
            (preProps.value !== this.props.value && !isNaN(this.props.value)) ||
            preProps.min !== this.props.min ||
            preProps.max !== this.props.max
        ) {
            this.updateSlider(this.props.value);
        }
    }

    // slider value change callback
    _callback = data => {
        if (this.props.callback) {
            this.props.callback(data);
        }
        this.setState({ isGray: false });

        let { hasUnit = false, unit, step = 1 } = this.props;
        let useValue = data.value;
        if (step >= 1) {
            useValue = parseInt(useValue);
        } else {
            const index = step.toString().indexOf('.') + 1;
            const digits = step.toString().slice(index).length;
            useValue = FJMathUtil.floor(useValue, digits);
        }
        if (hasUnit && !this.state.isFocus) useValue = useValue + unit;
        $(this._input).val(useValue);
    };

    _sliderInputValueSubmit = e => {
        if (e.keyCode === 13) {
            this._input.blur();
        } else if ((e.ctrlKey || e.metaKey) && e.keyCode === 65) {
            const value = $(this._input).val();
            this._input.value = '';
            this._input.value = value;
            this._input.select();
        }
    };

    _setIsFocus = (bool, callback) => {
        this.setState(
            {
                isFocus: bool,
            },
            () => {
                callback && callback();
            },
        );
    };

    /**
     * @description 失去焦点
     * @private
     */
    _inputBlur = () => {
        this._setIsFocus(false, this._updateSliderFromInput);
    };

    /**
     * @description 获取焦点
     * @private
     */
    _inputFocus = () => {
        this._setIsFocus(true);
        let { hasUnit = false, unit } = this.props;
        let value = $(this._input).val();
        if (value === UNDEFINED_VALUE) {
            $(this._input).val('');
            value = '';
        }
        this.setState({ isGray: false });
        if (hasUnit && value) {
            value = value.slice(0, value.length - unit.length);
            $(this._input).val(value);
        }

        this._input.value = '';
        this._input.value = value;
        //safari浏览器可能会被其他事件影响
        setTimeout(() => {
            this._input.select();
        }, 0);
    };

    _onMouseUp = e => {
        // e.preventDefault()
    };

    /**
     * @desc 从input中获取值来更新slider，从input中获取的数据只能有数字有小数点
     * @private
     */
    _updateSliderFromInput = () => {
        let inputValue = $(this._input).val();
        const { value, step = 1, max, min, callback } = this.props;
        const matches = /^(-?)0*(\d+\.\d+|\d+)$/.exec(inputValue);
        if (!matches) {
            inputValue = value;
        } else if (step < 1) {
            // 根据step来决定需要保留的位数
            inputValue = parseFloat(matches[0]);
            const index = step.toString().indexOf('.') + 1;
            const digits = step.toString().slice(index).length;
            inputValue = FJMathUtil.floor(inputValue, digits);
        } else {
            inputValue = parseInt(matches[1] + matches[2]);
        }

        if (inputValue === isNaN(inputValue)) inputValue = '';
        if (inputValue !== '') {
            if (inputValue > max) {
                inputValue = max;
            } else if (inputValue < min) {
                inputValue = min;
            }
        }

        this.updateSlider(inputValue);
        if (callback && inputValue !== '') {
            callback({ type: 'slideStart', value: inputValue });
            callback({ type: 'slideStop', value: inputValue });
        }
    };

    updateSlider = value => {
        let { hasUnit = false, unit = '', step = 1 } = this.props;
        let useValue = value;
        if (useValue === '') {
            if (!this.state.isFocus) useValue = UNDEFINED_VALUE;
        } else if (step >= 1) {
            useValue = parseInt(useValue);
        } else {
            const index = step.toString().indexOf('.') + 1;
            const digits = step.toString().slice(index).length;
            useValue = FJMathUtil.floor(useValue, digits);
        }
        this.setState({ isGray: value === '' && !this.state.isFocus });

        if (useValue && useValue !== UNDEFINED_VALUE && hasUnit && !this.state.isFocus) useValue = useValue + unit;
        $(this._input).val(useValue);
    };

    renderLabel = () => {
        const { name, labelClass } = this.props;
        return (
            <div className={className(Styles.name, labelClass)} ref={ele => (this.sliderName = ele)}>
                {name}
            </div>
        );
    };

    renderInput = () => {
        const { isGray } = this.state;
        return (
            <input
                type='text'
                className={className(Styles.input)}
                ref={ele => (this._input = ele)}
                onKeyDown={this._sliderInputValueSubmit}
                onBlur={this._inputBlur}
                onFocus={this._inputFocus}
                onMouseUp={this._onMouseUp}
                style={{ opacity: isGray ? '0.4' : 1 }}
            />
        );
    };

    renderSlider = () => {
        const { min, max, step, sliderID, sliderStyle, value } = this.props;
        return (
            <div className={Styles.slider} style={sliderStyle}>
                <FJSlider callback={this._callback} value={value} min={min} max={max} step={step} sliderID={sliderID} />
            </div>
        );
    };

    render() {
        const { disable, style, layout = FJConstant.TWO_ROW } = this.props;
        return (
            <div className={className(Styles.box, { [Styles.disable]: disable })} style={style}>
                {layout === FJConstant.TWO_ROW ? (
                    <div className={Styles.two_row}>
                        <div className={Styles.top_view}>
                            {this.renderLabel()}
                            {this.renderInput()}
                        </div>
                        {this.renderSlider()}
                    </div>
                ) : null}
                {layout === FJConstant.ONE_ROW ? (
                    <div className={Styles.one_row}>
                        {this.renderLabel()}
                        {this.renderSlider()}
                        {this.renderInput()}
                    </div>
                ) : null}
            </div>
        );
    }
}

export default FJResSliderInput;
